import React, { useEffect, useMemo, useState } from 'react';
import { Box, Image, Icon } from '@chakra-ui/react';
import { FaBox } from 'react-icons/fa';

const CYCLE_MS = 1000;

/**
 * Catalog card preview: while hovered, cycles through color main images every 1s.
 */
const MerchProductPreview = ({ images = [], alt = '', isHovered = false }) => {
  const urls = useMemo(() => {
    const seen = new Set();
    return (images || [])
      .map((item) => {
        if (typeof item === 'string') return item;
        return item?.url || null;
      })
      .filter((url) => {
        if (!url || seen.has(url)) return false;
        seen.add(url);
        return true;
      });
  }, [images]);

  const [index, setIndex] = useState(0);
  const canCycle = urls.length > 1;

  useEffect(() => {
    setIndex(0);
  }, [urls]);

  useEffect(() => {
    if (!canCycle || !isHovered) {
      setIndex(0);
      return undefined;
    }

    setIndex((prev) => (prev + 1) % urls.length);

    const timerId = setInterval(() => {
      setIndex((prev) => (prev + 1) % urls.length);
    }, CYCLE_MS);

    return () => clearInterval(timerId);
  }, [canCycle, isHovered, urls.length]);

  if (urls.length === 0) {
    return (
      <Box
        bg="gray.100"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon as={FaBox} boxSize={12} color="gray.400" />
      </Box>
    );
  }

  if (!canCycle) {
    return (
      <Image
        src={urls[0]}
        alt={alt}
        width="100%"
        height="100%"
        objectFit="contain"
        fallbackSrc="https://via.placeholder.com/400x400?text=Immagine+Non+Disponibile"
      />
    );
  }

  return (
    <Box position="relative" width="100%" height="100%">
      {urls.map((url, i) => (
        <Image
          key={url}
          src={url}
          alt={alt}
          position="absolute"
          inset={0}
          width="100%"
          height="100%"
          objectFit="contain"
          opacity={i === index ? 1 : 0}
          transition="opacity 0.6s ease"
          pointerEvents="none"
          fallbackSrc="https://via.placeholder.com/400x400?text=Immagine+Non+Disponibile"
        />
      ))}
    </Box>
  );
};

export default MerchProductPreview;
